import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import type { ListLikePostByIdPostId } from 'shared/types/list-likes-post-by-post-id'
import type { UseQueryClearOptions } from 'shared/types/tanstack-utility-types'
import { communityPostKeys } from './key-factory'

interface UsePostLikesOptions extends UseQueryClearOptions<
  ListLikePostByIdPostId[],
  Error,
  ListLikePostByIdPostId[]
> {
  postId: number
}

export const usePostLikes = ({
  postId,
  ...options
}: UsePostLikesOptions): UseQueryResult<ListLikePostByIdPostId[]> => {
  const { fetcher } = useApiWrapperWithErrorValidation<
    RequestMethodsEnum.get,
    ListLikePostByIdPostId[]
  >({ method: RequestMethodsEnum.get })

  return useQuery({
    queryKey: communityPostKeys.likes(postId),
    queryFn: async () => fetcher(`/api/community/post/${postId}/list-last-few-likes`),

    gcTime: Infinity,
    retry: false,
    refetchOnMount: 'always',
    refetchOnWindowFocus: false,
    refetchOnReconnect: 'always',
    ...options,
  })
}
